/*
 * @Author: RYL
 * @Description: 串口配置参数
 * @Date: 2021-01-13 11:40:51
 * @LastEditTime: 2021-01-13 13:51:03
 */
import i18n from "../common/lang"; //波特率选项

export var BaudRateList = [{
  value: "115200",
  label: "115200"
}, {
  value: "57600",
  label: "57600"
}, {
  value: "38400",
  label: "38400"
}, {
  value: "19200",
  label: "19200"
}, {
  value: "9600",
  label: "9600"
}, {
  value: "4800",
  label: "4800"
}, {
  value: "2400",
  label: "2400"
}, {
  value: "1800",
  label: "1800"
}, {
  value: "1200",
  label: "1200"
}, {
  value: "600",
  label: "600"
}, {
  value: "300",
  label: "300"
}, {
  value: "200",
  label: "200"
}, {
  value: "150",
  label: "150"
}, {
  value: "134",
  label: "134"
}, {
  value: "110",
  label: "110"
}]; //数据位选项

export var DataBitList = [{
  value: "6",
  label: "6"
}, {
  value: "7",
  label: "7"
}, {
  value: "8",
  label: "8"
} // { value: "自定义", label:i18n.t('lang.ConfigSetting.custom') }
]; //停止位选项

export var StopBitList = [{
  value: "1",
  label: "1"
}, {
  value: "2",
  label: "2"
} // { value: "自定义", label: i18n.t('lang.ConfigSetting.custom') }
]; //校验位选项

export var CheckDigitList = [{
  value: "S",
  label: "Space"
}, {
  value: "E",
  label: "Even"
}, {
  value: "M",
  label: "Mask"
}, {
  value: "O",
  label: "Odd"
}, {
  value: "N",
  label: "None"
}]; //流控选项

export var FlowControlList = [{
  value: "X",
  label: "XON/XOFF"
}, {
  value: "N",
  label: "None"
}];